import { defineMessages } from 'react-intl';

const messages = defineMessages({
  quote_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  maas_saas_sub_headline: {
    id: 'G2ONQb',
    defaultMessage:
      'IBM offers predictable, volume-based pricing to meet your needs.',
  },
  input_ingestion_text: {
    id: 'AXE8xw',
    defaultMessage: 'Daily log ingestion needed (GB/Day)',
  },
  return_est_text: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  gb_per_day: {
    id: 'K/i7Qg',
    defaultMessage: 'GB/Day',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  maas_saas_headline: {
    id: 'n8Ct5b',
    defaultMessage:
      'Calculate your estimated price for using QRadar SIEM (Cloud-Native)',
  },
  col2_text: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  col1_text: {
    id: 'jM00P1',
    defaultMessage: 'Ingestion',
  },
  estimated_daily_text: {
    id: '0Gta5e',
    defaultMessage: 'Effective GB/Day price ',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  input_ingestion_invalid: {
    id: 'gM0+XQ',
    defaultMessage: 'Please enter value between 50 - 10,000',
  },
  estimated_monthly_text: {
    id: 'lSIpRl',
    defaultMessage: 'Estimated monthly price',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  input_ingestion_tooltip: {
    id: 'NyaBCT',
    defaultMessage:
      'Simply input the daily estimated Gigabytes of log data to be ingested per day into QRadar SIEM (Cloud-Native). Log data will be used for detection analytics and threat investigation.',
  },
});

export default messages;
